export default {
  canDeletePlace: function () {
    return this.deletingObj && (
      (
        !this.deletingObj.totalOrders && !this.deletingObj.totalTrips
      ) ||
      this.replacementPlace
    );
  }
}
